import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectAuth } from '../state/auth';

const RedirectIfAuthenticated = () => {
  const auth = useSelector(selectAuth);

  if (auth !== null) {
    return <Navigate to="/portal/home" replace />;
  }

  return <Outlet />;
};

export default RedirectIfAuthenticated;
